import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Homepagesection from "../components/Homepagesection";
const Home = () => {
    return ( 
        <div>
            {/* SEO meta tags with Helmet */}
    
                       <Header />
              <section class="hero">
                    <div class="hero-overlay">
                       <div className="hero-slider">
  <div className="slide-text">Welcome to Construction Estimation</div>
  <div className="slide-text">Get Accurate Estimations in Seconds</div>
  <div className="slide-text">Your Digital Construction Partner</div>
</div>
                    </div>
                </section>
        <Navbar/>
  
        <div className="content-container">
         
          <Homepagesection />
          
        </div>
  
        
        <Footer />
      </div>
     );
}
 
export default Home;